import AsyncComponent from '@client/components/AsyncComponent'
import Loading from './loading'

export default AsyncComponent({
  component: () => import('./component'),
  loading: Loading,
})
